import React, { useCallback, useEffect, useMemo, useState, useRef } from "react";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  CircularProgress,
  Container,
  CssBaseline,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
// import RoomIcon from "@mui/icons-material/Room";
import ScheduleIcon from "@mui/icons-material/Schedule";
// import TableRestaurantIcon from "@mui/icons-material/TableRestaurant";
// import NotFound from "../Common/NotFound";
import { useDispatch, useSelector } from "react-redux";
import LocationCityIcon from '@mui/icons-material/LocationCity';
import { MdMyLocation } from "react-icons/md";
import { TbMapShare } from "react-icons/tb";
import { LuMapPin } from "react-icons/lu";
import { postAPI } from "../api/callAPI";
import { debounce, get, isArray, isString, uniq } from "lodash";
import {
  // setEndPoint,
  setStoreData as setStore,
  setUserLocation,
  setSearchQuery,
} from "../redux/action";
import { useNavigate, useSearchParams } from "react-router";
import "./home.css";
// eslint-disable-next-line no-unused-vars
import { ChevronRightSharp, SearchOutlined, ChevronLeft, ChevronRight, LocationCity } from "@mui/icons-material";
import RLLogo from "../Images/RL-white-logo.webp";
import moment from "moment/moment";
// import axios from "axios";
import useStoresListByTextAndLatLong from "../hooks/useStoresListByTextAndLatLong";
import { useDocumentTitle } from "../hooks/useDocumentTitle";
import { getConfigText } from "../Common/utils";

// const locations = new Array(9).fill({
//   name: "Romeo Lane - Civil Lines Delhi",
//   address: "13 Second Floor, Alipur Road, Civil Lines, Delhi.",
//   image: "https://via.placeholder.com/300x150", // Replace with actual image URL
//   directions: "Get directions",
//   openUntil: "Open until 3:00pm",
// });

const locationImages = {
  delhi: "delhi.svg",
  goa: "goa.svg",
  noida: "noida.svg",
  zirakpur: "zirakpur.svg",
  gurugram: "gurugram.svg",
  meerut: "meerut.svg",
  bhopal: "bhopal.svg",
  bhubaneswar: "bhubaneswar.svg",
  lucknow: "lucknow.svg",
  dubai: "dubai.svg",
};

export default function Home() {
  useDocumentTitle("Outlet Listing");
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const locationGridRef = useRef(null);

  // const [storeData, setStoreData] = useState("");

  // const [searchText, setSearchText] = useState("");

  // const [storeList, setStoreList] = useState([]);
  // const [apiLoading, setApiLoading] = useState(false);
  const [storeLocation, setStoreLocation] = useState("");
  // const [apiError, setApiError] = useState(null);

  const [storeSearchList, setStoreSearchList] = useState([]);
  const [searchTriggered, setSearchTriggered] = useState(false);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const { endpoint, userLocation, searchText, appConfigs } = useSelector(
    (state) => state.auth
  );

  // Check if v=home query parameter exists
  const showButtons = useMemo(() => {
    const vParam = searchParams.get("v");
    return process.env.NODE_ENV === "development" ? true : vParam === "home";
  }, [searchParams]);

  const bookTableEnabled = useMemo(() => {
    const enabled = getConfigText(appConfigs, "book_a_table_enabled");
    return enabled === "1" || enabled === "true";
  }, [appConfigs]);

  const {
    isLoading: apiLoading,
    data: storeList,
    refetch,
  } = useStoresListByTextAndLatLong();

  const handleSearch = useCallback(
    (value) => {
      console.log("Searching:", value);
      // API call or logic here
      // console.log("handleSearch >> ", value);
      // setSearchText(value);
      refetch();
    },
    [refetch]
  );

  const debouncedSearch = useMemo(
    () => debounce(handleSearch, 3000),
    [handleSearch]
  );

  const handleSearchInput = (evt) => {
    const str = evt?.target.value;
    // console.log("handleSearch >> ", str);
    // setSearchText(str);
    dispatch(setSearchQuery(str));
    if (locationArray.indexOf(str) > -1) {
      setStoreLocation("");
    }
    debouncedSearch(str);
  };

  const locationArray = useMemo(() => {
    if (isArray(storeList) && storeList.length > 0) {
      const locations = uniq(storeList.map((item) => item?.city));
      return uniq(locations);
    }
    return [];
  }, [storeList]);

  // const checkStore = async (endpoint1) => {
  //   setApiLoading(true);
  //   try {
  //     // const mResp = await getAPI(endpoint1, "admin/get-active-store-for-admin");
  //     const mResp = await postAPI(
  //       endpoint1,
  //       "stores-list-by-text-and-lat-long"
  //     );
  //     // console.log("mResp >>> ", mResp);
  //     if (mResp?.success) {
  //       if (isArray(mResp?.data) && mResp.data.length > 0) {
  //         const storesList = mResp.data;
  //         if (storesList.length === 1) {
  //           const singleStoreID = storesList[0]?.id;
  //           const resp = await getAPI(endpoint1, `stores/${singleStoreID}`);
  //           console.log("resp >>> ", resp);
  //           // setstoreData(resp?.data["0"]);
  //           // setStoreData(resp?.data["0"]);
  //           dispatch(setStore(resp?.data["0"]));
  //           navigate(`/store/${singleStoreID}`);
  //         } else {
  //           // multistore
  //           // setStoreData(resp?.data["0"]);
  //           setStoreList(mResp?.data);
  //           // dispatch(setStore(resp?.data["0"]));
  //         }
  //       } else {
  //         dispatch(setStore({}));
  //       }
  //     }
  //     setApiLoading(false);
  //   } catch {
  //     dispatch(setStore({}));
  //     setApiLoading(false);
  //   }
  // };

  useEffect(() => {
    if (!storeLocation) return;
    const fetchStores = async () => {
      if (storeLocation === "all") {
        // refetch();
      } else {
        try {
          const mResp = await postAPI(endpoint, "get-store-base-on-city-name", {
            city_name: storeLocation,
          });

          if (mResp?.success) {
            if (isArray(mResp?.data) && mResp.data.length > 0) {
              // const storesList = mResp.data;
              // setStoreSearchList(storesList);
              setStoreSearchList(mResp.data);
              console.log("Stores in Delhi:", mResp.data);
            }
          }

          // const { data } = await axios.post(
          //   "https://romeolane.feedthetummy.com/api/get-store-base-on-city-name",
          //   {
          //     city_name: storeLocation,
          //   }
          // );
          // setStoreSearchList(data.data);
          // console.log("Stores in Delhi:", data);
        } catch (error) {
          console.error("Failed to fetch stores:", error);
        }
      }
    };

    fetchStores();
  }, [endpoint, storeLocation]);

  useEffect(() => {
    dispatch(
      setStore({
        // store: {
        id: 0,
        name: "Romeo Lane",
        image: RLLogo,
        // },
      })
    );
  }, [dispatch]);

  const getUserLocation = () => {
    // if geolocation is supported by the users browser
    if (navigator.geolocation) {
      // get the current users location
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // save the geolocation coordinates in two variables
          const { latitude, longitude } = position.coords;

          dispatch(setUserLocation({ latitude, longitude }));
          refetch();
        },
        // if there was an error getting the users location
        (error) => {
          console.error("Error getting user location:", error);
        }
      );
    }
    // if geolocation is not supported by the users browser
    else {
      console.error("Geolocation is not supported by this browser.");
    }
  };

  const bookATable = (item) => {
    // console.log("item >> ", item);
    // console.log("setStore", setStore);
    // setStoreData(item);
    dispatch(setStore(item));
    // navigate(`/store/${item?.id}`);
    navigate(`/web/${item?.slug || ""}/book-a-table`);
  };

  const openDetails = (item) => {
    // console.log("item", item);
    // console.log("setStore", setStore);
    // setStoreData(item);
    dispatch(setStore(item));
    // if (process.env.NODE_ENV === "development") {
    //   navigate(`/speed-booking/${item?.id}`);
    // } else {
    // navigate(`/details/${item?.id}`);
    navigate(`/web/${item?.slug || ""}`);
    // }
  };

  useEffect(() => {
    const fetchStoreByLatLong = async () => {
      setSearchTriggered(true);
      try {
        // const mResp = await getAPI(endpoint1, "admin/get-active-store-for-admin");
        let reqData = {};
        //   let text = '';
        const lat = get(userLocation, "latitude");
        const lng = get(userLocation, "longitude");
        if (lat && lng) {
          reqData.lat = lat;
          reqData.long = lng;
        }

        const mResp = await postAPI(
          endpoint,
          "stores-list-by-text-and-lat-long",
          reqData
        );
        // console.log("mResp >>> ", mResp);
        if (mResp?.success) {
          if (isArray(mResp?.data) && mResp.data.length > 0) {
            const storesList = mResp.data;
            setStoreSearchList(storesList);
          }
        }
      } catch (err) {
        console.error(err);
        setStoreSearchList([]);
      }
    };
    if (userLocation) {
      fetchStoreByLatLong();
    } else {
      setSearchTriggered(false);
      setStoreSearchList([]);
    }
  }, [dispatch, endpoint, userLocation]);

  useEffect(() => {
    const fetchStoreBySearchText = async () => {
      setSearchTriggered(true);
      try {
        // const mResp = await getAPI(endpoint1, "admin/get-active-store-for-admin");
        let reqData = {};
        //   let text = '';
        // const lat = get(userLocation, "latitude");
        // const lng = get(userLocation, "longitude");
        // if (lat && lng) {
        //   reqData.lat = lat;
        //   reqData.long = lng;
        // }

        if (searchText && searchText !== "" && searchText.length > 2) {
          reqData.text = searchText;
        }

        const mResp = await postAPI(
          endpoint,
          "stores-list-by-text-and-lat-long",
          reqData
        );
        // console.log("mResp >>> ", mResp);
        if (mResp?.success) {
          if (isArray(mResp?.data) && mResp.data.length > 0) {
            const storesList = mResp.data;
            setStoreSearchList(storesList);
          }
        }
      } catch (err) {
        console.error(err);
        setStoreSearchList([]);
      }
    };
    if (searchText && searchText !== "" && searchText.length > 2) {
      fetchStoreBySearchText();
    } else {
      setSearchTriggered(false);
      setStoreSearchList([]);
    }
  }, [endpoint, searchText]);

  const handleStoreLocation = useCallback(
    (str) => {
      dispatch(setSearchQuery(""));
      setStoreLocation(str);
    },
    [dispatch]
  );

  // useEffect(() => {
  //   if (isObject(storeData) && Object.keys(storeData).length > 0) {
  //     dispatch(setStore(storeData));
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [storeData]);

  useEffect(() => {
    dispatch(setUserLocation(null));
  }, [dispatch]);

  useEffect(() => {
    if (storeLocation) {
      if (storeLocation?.toLocaleLowerCase() === searchText?.toLowerCase()) {
        setStoreLocation(searchText);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  // useEffect(() => {
  //   if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  //     checkStore(endpoint);
  //     dispatch(setEndPoint(endpoint));
  //   } else {
  //     const parts = window.location.host.split(".");
  //     if (parts.length >= 3) {
  //       dispatch(setEndPoint(parts[0]));
  //       checkStore(parts[0]);
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const isSelectedLocation = (loc = "") => {
    if (searchText?.toLowerCase() === loc.toLowerCase()) {
      return true;
    } else if (
      searchText === "" &&
      isString(storeLocation) &&
      storeLocation.toLowerCase() === loc?.toLowerCase()
    ) {
      return true;
    }

    // else if (loc === "all" && searchText === "") {
    //   return true;
    // }
    return false;
  };

  // Check scroll position to enable/disable arrows
  const checkScrollButtons = useCallback(() => {
    if (locationGridRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = locationGridRef.current;
      const hasOverflow = scrollWidth > clientWidth;
      
      setCanScrollLeft(hasOverflow && scrollLeft > 10);
      setCanScrollRight(hasOverflow && scrollLeft < scrollWidth - clientWidth - 10);
    }
  }, []);

  // Scroll left
  const scrollLeft = () => {
    if (locationGridRef.current) {
      // Adjust scroll amount based on screen size
      const scrollAmount = window.innerWidth < 768 ? 150 : 220;
      locationGridRef.current.scrollBy({ left: -scrollAmount, behavior: "smooth" });
      setTimeout(checkScrollButtons, 300);
    }
  };

  // Scroll right
  const scrollRight = () => {
    if (locationGridRef.current) {
      // Adjust scroll amount based on screen size
      const scrollAmount = window.innerWidth < 768 ? 150 : 220;
      locationGridRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
      setTimeout(checkScrollButtons, 300);
    }
  };

  // Check scroll on mount and on location array change
  useEffect(() => {
    const gridElement = locationGridRef.current;
    
    // Reset scroll position to start
    if (gridElement) {
      gridElement.scrollLeft = 0;
    }
    
    // Small delay to ensure DOM is ready
    setTimeout(() => {
      checkScrollButtons();
    }, 100);
    
    // Add event listener for scroll
    if (gridElement) {
      gridElement.addEventListener("scroll", checkScrollButtons);
      // Also check on resize
      window.addEventListener("resize", checkScrollButtons);
    }
    
    return () => {
      if (gridElement) {
        gridElement.removeEventListener("scroll", checkScrollButtons);
      }
      window.removeEventListener("resize", checkScrollButtons);
    };
  }, [locationArray, checkScrollButtons]);

  const renderLocationItem = (location, index, key) => {
    return (
      <Grid
        item
        xs={12}
        sm={8}
        md={6}
        lg={4}
        key={`${key}_${location?.id}_${index}`}
      >
        <Card
          sx={{
            boxShadow: "none",
            mb: 2,
          }}
          className="img-box"
        >
          <CardMedia
            component="img"
            height="210"
            image={location.image}
            alt={location.name}
          />
          <CardContent
            sx={{
              textAlign: "left",
              padding: "8px 0px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexDirection: "column",
            }}
          >
            <Box
              display={"flex"}
              // justifyContent={"space-between"}
              flexDirection={"column"}
              sx={{
                height: 150,
                width: "100%",
                mb: 1,
              }}
            >
              <Typography
                variant="subtitle1"
                className="box-title"
                fontWeight="bold"
              >
                {location.name}
              </Typography>
              <Box
                sx={{
                  overflow: "hidden",
                  // height: 45,
                }}
                className="location-box"
              >
                <Typography
                  variant="body2"
                  sx={{
                    textOverflow: "ellipsis",
                  }}
                  className="content-box"
                >
                  <LuMapPin />{" "}
                  <span className="location-span">{`${location.address_line_1}, ${location.address_line_2}, ${location.city}`}</span>
                </Typography>
              </Box>

              {/* City icon - always visible */}
              <Box
                sx={{
                  mt: 1,
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <LocationCity sx={{ fontSize: 18, color: "#666" }} />
                <Typography variant="body2" sx={{ color: "#666", fontWeight: 500 }}>
                  {location.city}
                </Typography>
              </Box>

              <Box
                sx={{
                  mt: 2,
                }}
                className="contentbox"
              >
                <Typography variant="body2" sx={{}}>
                  {location.description || ""}
                  {/* {
                    " jdf joire joijr e ero ijger pgj erpg j ejepro gjpo ergpeor gjoer j erpgo jpero gjop re jg pe rogje ofop fpe orrope prej gpjegpj erpgjpr ejp"
                  } */}
                </Typography>
              </Box>
            </Box>

            <Box
              display="flex"
              alignItems="center"
              justifyContent={"space-between"}
              sx={{
                width: "100%",
                flexDirection: "row",
              }}
            >
              <Box
                display="flex"
                alignItems="center"
                gap={1}
                mt={1}
                className="direction-text"
              >
                <TbMapShare />
                <Typography
                  variant="body2"
                  component="a"
                  href={`https://www.google.com/maps/dir/?api=1&destination=${location.lat},${location.long}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ textDecoration: "none", cursor: "pointer" }}
                >
                  Get Directions
                </Typography>
              </Box>
              {location?.open_close_time ? (
                <Box
                  display="flex"
                  alignItems="center"
                  gap={1}
                  mt={1}
                  mr={1}
                  className="open-text"
                >
                  <ScheduleIcon />
                  <Typography variant="body2">{`Open until ${moment(
                    location?.open_close_time?.closing_time,
                    "HH:mm:ss"
                  ).format("h:mm A")}`}</Typography>
                </Box>
              ) : (
                <Box display="flex" alignItems="center" gap={1} mt={1} mr={1} />
              )}
            </Box>
          </CardContent>
          {showButtons && (
            <CardActions
              className={bookTableEnabled ? undefined : "single-action"}
              sx={{
                padding: "0px",
                flexDirection: "column",
              }}
            >
              {bookTableEnabled && (
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  sx={{
                    minHeight: 45,
                  }}
                  onClick={() => bookATable(location)}
                  className="main-btn"
                >
                  Book a table
                </Button>
              )}

              <Button
                fullWidth
                variant="outlined"
                color="primary"
                sx={{
                  minHeight: 45,
                  mt: 0,
                }}
                onClick={() => openDetails(location)}
                className="border-btn"
              >
                Visit Website
              </Button>
            </CardActions>
          )}
        </Card>
      </Grid>
    );
  };

  // if (apiLoading) {
  //   return (
  //     <Container maxWidth="lg">
  //       <CircularProgress variant="indeterminate" />
  //     </Container>
  //   );
  // }

  // if (typeof storeData == "object" && !Object.keys(storeData).length) {
  //   return <NotFound />;
  // }

  return (
    <>
      <CssBaseline />
      <Box
        textAlign="center"
        py={4}
        px={2}
        sx={{
          backgroundColor: "#F0F0F0",
        }}
        className="main-contain"
      >
        <Typography variant="h6" className="search-title">
          Let's help you find an outlet near you.
        </Typography>
        <TextField
          fullWidth
          hiddenLabel
          size="small"
          variant="outlined"
          placeholder="Enter town or city"
          onChange={handleSearchInput}
          value={searchText}
          className="search-input-new"
          sx={{
            my: 2,
            maxWidth: "500px",
            textAlign: "center",
            alignItems: "center",
            backgroundColor: "#FFFFFF",
          }}
          //   inputProps={{}}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchOutlined color="#000000" />
                <MdMyLocation
                  className="location-icon"
                  onClick={getUserLocation}
                />
              </InputAdornment>
            ),
          }}
        />

        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", px: { xs: 2, md: 0 } }}>
          <div className="location-grid-wrapper">
            {canScrollLeft && (
              <button 
                className="location-scroll-btn left" 
                onClick={scrollLeft}
                aria-label="Scroll left"
              >
                <ChevronLeft />
              </button>
            )}
            
            <div 
              className="location-grid" 
              ref={locationGridRef}
              style={{ 
                paddingLeft: canScrollLeft ? "50px" : "0",
                paddingRight: canScrollRight ? "50px" : "0",
                justifyContent: (!canScrollLeft && !canScrollRight) ? "center" : "flex-start",
                transition: "padding 0.3s ease"
              }}
            >
              <div
                className={`grid-inner ${isSelectedLocation("all") ? "location-selected" : ""
                  } `}
                onClick={() => {
                  handleStoreLocation("all");
                  setStoreSearchList([]);
                  // refetch();
                }}
              >
                <img src="location.png" alt="All" />
                <p>All</p>
              </div>

              {locationArray.map((loc, ii) => {

                const kL = loc.toLocaleLowerCase();

                const image = get(locationImages, kL);
                return (
                  <div
                    key={`${kL}_${ii}`}
                    className={`grid-inner ${isSelectedLocation(kL) ? "location-selected" : ""
                      } `}
                    onClick={() => {
                      handleStoreLocation(kL);
                      setStoreSearchList([]);
                      // refetch();
                    }}
                  >

                    {image ? (
                      <img src={image} alt={loc} style={{
                        // border: "1px solid #FF0000",
                      }} />
                    ) : (
                      <LocationCityIcon sx={{ height: 50, width: 50 }} color="grey"  />
                    )}
                    {/* <img src={image || "location.png"} alt={loc} /> */}
                    <Typography 
                      variant="body2"
                      sx={{
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        wordBreak: 'no-break',
                        lineHeight: '1.2',
                        maxHeight: '2.4em', // 2 lines * line-height
                      }}
                    >
                      {/* {loc?.substring(0, 10)} */}
                      {loc}
                    </Typography>
                  </div>
                );
              })}
            </div>
            
            {canScrollRight && (
              <button 
                className="location-scroll-btn right" 
                onClick={scrollRight}
                aria-label="Scroll right"
              >
                <ChevronRight />
              </button>
            )}
          </div>
        </Box>
      </Box>

      {apiLoading ? (
        <Container maxWidth="lg" sx={{ marginBottom: 4 }}>
          <CircularProgress variant="indeterminate" />
        </Container>
      ) : (
        <Container maxWidth="lg" sx={{ marginBottom: 4 }}>
          {storeSearchList?.length > 0 && (
            <Typography
              variant="h6"
              className="titlemain text-center"
              align="center"
              mt={4}
              mb={2}
            >
              We’ve found {storeSearchList?.length} restaurant(s) close to you!
            </Typography>
          )}
          {searchTriggered && storeSearchList?.length === 0 && (
            <Typography
              variant="h6"
              align="center"
              className="titlemain text-center mb-0"
              mt={4}
              mb={0}
            >
              Can’t find an outlet near you? No worries — we’re just a drive
              away!
            </Typography>
          )}

          {storeSearchList?.length === 0 && (
            <Typography className="titlemain" variant="h6" my={4}>
              We're proudly serving our customers at {storeList.length}{" "}
              location(s)
              {/* across India and at Dubai International. */}
            </Typography>
          )}

          <Grid
            container
            spacing={3}
            className="grid-padd"
            justifyContent={"flex-start"}
            sx={{
              marginTop: 1,
            }}
          >
            {storeSearchList?.length > 0 &&
              storeSearchList.map((location, index) =>
                renderLocationItem(location, index, "search-store-item")
              )}
            {storeSearchList?.length === 0 &&
              storeList?.length > 0 &&
              storeList?.map((location, index) =>
                renderLocationItem(location, index, "store-item")
              )}
          </Grid>
        </Container>
      )}
    </>
  );
}
